import classNames from 'classnames';
import { FormEvent, useState } from 'react';
import {
  BUTTON_TEXT_CLASS_NAME,
  CARD_CLASS_NAME,
  PRIMARY_BUTTON_CLASS_NAME,
  SECONDARY_BUTTON_CLASS_NAME,
} from '../StartScreen/styles';
import ThemeControl from '../ThemeControl/ThemeControl';
import './HomeScreen.css';

interface IHomeScreenProps {
  previousName: string;
  viewLobbiesClicked: (newName: string) => void;
  dailyChallengeClicked: (newName: string) => Promise<void>;
}

export default function HomeScreen({
  previousName,
  viewLobbiesClicked,
  dailyChallengeClicked,
}: IHomeScreenProps) {
  const [name, setName] = useState(previousName);
  const [startingDailyChallenge, setStartingDailyChallenge] = useState(false);
  const trimmedName = name.trim();

  const onDailyChallengeClick = async () => {
    setStartingDailyChallenge(true);
    try {
      await dailyChallengeClicked(trimmedName);
    } finally {
      setStartingDailyChallenge(false);
    }
  };

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (trimmedName) {
      viewLobbiesClicked(trimmedName);
    }
  };

  return (
    <main className="flex min-h-0 flex-1 flex-col items-center overflow-y-auto px-[16px] py-[24px]">
      <div className="my-auto flex w-full max-w-[360px] flex-col items-center gap-[28px]">
        <div className="flex flex-col items-center gap-[8px]">
          <img
            src="/limajuice.png"
            alt=""
            className="size-[112px] object-contain"
          />
          <h1 className="text-[28px] font-bold tracking-[-0.5px]">
            Tens &amp; Twos
          </h1>
        </div>
        <form
          onSubmit={onSubmit}
          className={classNames(
            CARD_CLASS_NAME,
            'flex w-full flex-col gap-[14px] p-[16px]'
          )}
        >
          <label className="home-name-field flex flex-col gap-[8px]">
            <span className="px-[4px] text-[13px] font-bold text-ink-muted">
              Your name
            </span>
            <input
              type="text"
              className="home-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoComplete="nickname"
              autoCapitalize="words"
              enterKeyHint="go"
            />
          </label>
          <button
            type="submit"
            disabled={!trimmedName}
            className={PRIMARY_BUTTON_CLASS_NAME}
          >
            <span className={BUTTON_TEXT_CLASS_NAME}>Play</span>
          </button>
          <button
            type="button"
            disabled={!trimmedName || startingDailyChallenge}
            onClick={onDailyChallengeClick}
            className={SECONDARY_BUTTON_CLASS_NAME}
          >
            <span className={BUTTON_TEXT_CLASS_NAME}>
              {startingDailyChallenge
                ? 'Starting daily challenge…'
                : 'Daily challenge'}
            </span>
          </button>
        </form>
        <div className="flex w-full flex-col gap-[8px]">
          <span
            aria-hidden="true"
            className="px-[4px] text-[13px] font-bold text-ink-muted"
          >
            Theme
          </span>
          <ThemeControl />
        </div>
      </div>
    </main>
  );
}
